import React, { useState } from "react";
import ProductsNavRow from "../rownavigator";

const BuildingHardware = () => {
  // State
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [activeNestedOption, setActiveNestedOption] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const building_hardware = {
    name: "Building Hardware",
    subcategories: {
      building_supplies: {
        name: "Building Supplies",
        options: {
          concrete_products: {
            name: "Concrete Products",
            images: ["/assets/productimages/concreteproducts.jpg"],
            products: [
              {
                name: "Prefabricated Concrete Support Structures",
                image: "/assets/productimages/concreteproducts.jpg",
                use: "Structural support in construction",
                details: "Precast concrete elements for various construction needs",
                price: "",
              },
            ],
          },
          paving: {
            name: "Paving",
            options: {
              driveway_paving: {
                name: "Driveway & Porcelain",
                images: ["/assets/productimages/paving.jpg"],
                products: [
                  {
                    name: "Porcelain Paving Stones",
                    image: "/assets/productimages/paving.jpg",
                    use: "Exterior flooring solutions",
                    details: "Durable porcelain paving for driveways and patios",
                    price: "",
                  },
                ],
              },
              block_paving: {
                name: "Block Paving",
                images: ["/assets/productimages/paving2.jpg"],
                products: [
                  {
                    name: "Pavement Blocks",
                    image: "/assets/productimages/paving2.jpg",
                    use: "Driveway and pavement materials",
                    details: "Interlocking concrete blocks for various applications",
                    price: "",
                  },
                ],
              },
            },
          },
          roofing: {
            name: "Roofing",
            options: {
              tiles: {
                name: "Roofing Tiles",
                images: ["/assets/productimages/rooftiles.jpg"],
                products: [
                  {
                    name: "Clay Roof Tiles",
                    image: "/assets/productimages/rooftiles.jpg",
                    use: "Roof coverings for buildings",
                    details: "Traditional clay tiles in various colors and profiles",
                    price: "",
                  },
                ],
              },
              drainage: {
                name: "Guttering & Drainage",
                images: ["/assets/productimages/guttering.jpg"],
                products: [
                  {
                    name: "PVC Guttering System",
                    image: "/assets/productimages/guttering.jpg",
                    use: "Water management systems for roofs",
                    details: "Complete rainwater collection system",
                    price: "",
                  },
                ],
              },
            },
          },
        },
      },
      facades_fencing: {
        name: "Facades & Fencing",
        options: {
          doors: {
            name: "Doors",
            options: {
              internal: {
                name: "Internal Doors",
                images: ["/assets/productimages/door.webp"],
                products: [
                  {
                    name: "Panel Interior Door",
                    image: "/assets/productimages/door.webp",
                    use: "Internal access solutions",
                    details: "Standard 1981x762mm internal door",
                    price: "",
                  },
                ],
              },
              external: {
                name: "External Doors",
                images: ["/assets/productimages/externaldoors.jpg"],
                products: [
                  {
                    name: "Composite Front Door",
                    image: "/assets/productimages/externaldoors.jpg",
                    use: "External access solutions",
                    details: "Weather-resistant composite entry door",
                    price: "",
                  },
                ],
              },
            },
          },
          windows: {
            name: "Windows",
            options: {
              upvc: {
                name: "uPVC Windows",
                images: ["/assets/productimages/pvcwindow.jpg"],
                products: [
                  {
                    name: "Double Glazed uPVC Casement Window",
                    image: "/assets/productimages/pvcwindow.jpg",
                    use: "uPVC window solutions",
                    details: "Energy efficient A-rated windows",
                    price: "",
                  },
                ],
              },
              aluminium: {
                name: "Aluminium Windows",
                images: ["/assets/productimages/aluminiumwindow.jpg"],
                products: [
                  {
                    name: "Slimline Aluminium Frame Window",
                    image: "/assets/productimages/aluminiumwindow.jpg",
                    use: "Aluminium window solutions",
                    details: "Modern slim-profile windows",
                    price: "",
                  },
                ],
              },
            },
          },
        },
      },
      timber_sheet_materials: {
        name: "Timber & Sheet Materials",
        options: {
          plywood: {
            name: "Plywood",
            images: ["/assets/productimages/plywood.jpg"],
            products: [
              {
                name: "Structural Plywood 18mm",
                image: "/assets/productimages/plywood.jpg",
                use: "Versatile wood panel product",
                details: "WBP exterior grade plywood",
                price: "",
              },
            ],
          },
          ceiling_panels: {
            name: "Ceiling Panels",
            images: ["/assets/productimages/plywoodceiling.jpg"],
            products: [
              {
                name: "PVC Ceiling Panels",
                image: "/assets/productimages/plywoodceiling.jpg",
                use: "Ceiling covering solutions",
                details: "Lightweight moisture-resistant panels",
                price: "",
              },
            ],
          },
        },
      },
    },
  };

  // Handlers
  const handleSubcategoryClick = (key) => {
    setActiveSubcategory(key);
    setActiveOption(null);
    setActiveNestedOption(null);
  };

  const handleOptionClick = (key) => {
    setActiveOption(key);
    setActiveNestedOption(null);
  };

  const handleNestedOptionClick = (key) => {
    setActiveNestedOption(key);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => setSelectedProduct(null);

  // Render
  const renderSubcategories = () => (
    <div className="mb-3">
      <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
      <div className="flex flex-wrap gap-2">
        {Object.entries(building_hardware.subcategories).map(([key, sub]) => (
          <button
            key={key}
            onClick={() => handleSubcategoryClick(key)}
            className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
              ? "bg-blue-500 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
          >
            {sub.name}
          </button>
        ))}
      </div>
    </div>
  );

  const renderOptions = () => {
    if (!activeSubcategory) return null;
    const sub = building_hardware.subcategories[activeSubcategory];
    if (!sub.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(sub.options).map(([key, opt]) => (
            <button
              key={key}
              onClick={() => handleOptionClick(key)}
              className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                ? "bg-green-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
            >
              {opt.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderNestedOptions = () => {
    if (!activeSubcategory || !activeOption) return null;
    const opt =
      building_hardware.subcategories[activeSubcategory].options[activeOption];
    if (!opt.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">More Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(opt.options).map(([key, nested]) => (
            <button
              key={key}
              onClick={() => handleNestedOptionClick(key)}
              className={`px-3 py-1 rounded-full text-sm ${activeNestedOption === key
                ? "bg-purple-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
            >
              {nested.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderProducts = () => {
    let products = [];

    if (activeSubcategory && activeOption && activeNestedOption) {
      products =
        building_hardware.subcategories[activeSubcategory].options[activeOption]
          .options[activeNestedOption].products || [];
    } else if (activeSubcategory && activeOption) {
      products =
        building_hardware.subcategories[activeSubcategory].options[activeOption]
          .products || [];
    } else if (activeSubcategory) {
      products =
        building_hardware.subcategories[activeSubcategory].products || [];
    }

    if (!products.length) {
      return (
        <div className="text-center py-10 text-gray-500">
          No products available
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p, idx) => (
          <div
            key={idx}
            className="border rounded-lg shadow hover:shadow-lg cursor-pointer"
            onClick={() => handleProductClick(p)}
          >
            <img
              src={p.image}
              alt={p.name}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="font-semibold text-lg">{p.name}</h3>
              <p className="text-gray-600">{p.use}</p>
              <p className="text-blue-600 font-bold">{p.price}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderModal = () =>
    selectedProduct && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg max-w-lg w-full overflow-hidden">
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-xl font-bold">{selectedProduct.name}</h2>
            <button onClick={closeModal}>&times;</button>
          </div>
          <img
            src={selectedProduct.image}
            alt={selectedProduct.name}
            className="w-full h-64 object-cover"
          />
          <div className="p-4 space-y-2">
            <p>
              <strong>Uses:</strong> {selectedProduct.use}
            </p>
            <p>
              <strong>Details:</strong> {selectedProduct.details}
            </p>

          </div>
          <div className="p-4 flex justify-end border-t">
            <button
              onClick={closeModal}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );

  return (
    <>
      <ProductsNavRow />
      <div className="container mx-auto px-4 py-2">
        <h1 className="text-3xl font-bold mb-3">{building_hardware.name}</h1>
        {renderSubcategories()}
        {renderOptions()}
        {renderNestedOptions()}
        {renderProducts()}
        {renderModal()}
      </div>
    </>
  );
};

export default BuildingHardware;
